import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import greendot from '../../../../Assets/greendot.png';
import reddot from '../../../../Assets/reddot.png';
import { useTranslation } from 'react-i18next';
const AshaSchemeView = ({allAshaScheme}) => {
  const { t } = useTranslation('Scheme');
    const [activeSchemes, setActiveSchemes] = useState([]);
    const [inactiveSchemes, setInactiveSchemes] = useState([]);
    const [filters, setFilters] = useState(null);

    const initFilters = () => {
      setFilters({
        activityname: { value: "", matchMode: FilterMatchMode.CONTAINS }
      });
  };
  useEffect(() => {
    if (allAshaScheme && allAshaScheme.schemeDetails) {
      const availedSchemes = allAshaScheme.schemeDetails.filter(scheme => scheme.status === 'Availed');
      const nonAvailedSchemes = allAshaScheme.schemeDetails.filter(scheme => scheme.status === 'Non-Availed');
      setActiveSchemes(availedSchemes);
      setInactiveSchemes(nonAvailedSchemes);
    }
    initFilters();
  }, [allAshaScheme]);
    const nonAvailedSchemesFilterTemplate = (options) => {
        return (
            <div class="p-input-icon-right">
                <i class="pi pi-search custom-search-icon" />
                <InputText
                    type="text"
                    value={options.value}
                    onChange={(e) => options.filterApplyCallback(e.target.value)}
                    placeholder={t("Search")}
                    className="p-column-filter font-normal text-sm"
                    style={{color: "#2C3D8F"}}
                    data-testid="nonavailed-schemes-search-input"
                />
            </div>
        );
    };

    const availedSchemesFilterTemplate = (options) => {
      return (
          <div class="p-input-icon-right">
              <i class="pi pi-search custom-search-icon" />
              <InputText
                  type="text"
                  value={options.value}
                  onChange={(e) => options.filterApplyCallback(e.target.value)}
                  placeholder={t("Search")}
                  className="p-column-filter font-normal text-sm"
                  style={{color: "#2C3D8F"}}
                  data-testid="availed-schemes-search-input"
              />
          </div>
      );
  };
  const renderSchema = (rowData) => (
    <span style={{ color: "#2C3D8F" }} class="font-normal text-xs">
    {rowData.activityname}
  </span>
  );
  return (
    <div data-testid="asha-scheme-view" class="grid">
      <div class="sm:col-12 md:col-6 sm:mb-4 md:mb-0">
        <div data-testid="availed-schemes" class="shadow-5 border-round-lg p-3">
          <div class="flex align-items-center mb-2">
            <img src={greendot} alt="" />
            <p class="font-normal text-sm pl-1">
             {t('SchemesAvailed')}
            </p>
          </div>
          <DataTable
            value={activeSchemes}
            scrollable
            scrollHeight="18rem"
            filters={filters}
            filterDisplay="row"
          >
            <Column
              field="activityname"
              header={t('SchemeName')}
              headerStyle={{ color: "#333333", fontSize: "12px", fontWeight: 600 }}
              body={(rowData) => (
                renderSchema(rowData)
              )}
              filter
              filterPlaceholder={t('Search')}
              showFilterMenu={false}
              filterElement={availedSchemesFilterTemplate}
            ></Column>
          </DataTable>
          <p data-testid="availed-schemes-total"
            class="font-medium text-sm">{activeSchemes.length} {t('TotalRecords')}</p>
        </div>
      </div>
      <div class="sm:col-12 md:col-6">
        <div data-testid="non-availed-schemes" class="shadow-5 border-round-lg p-3">
          <div class="flex justify-content-between align-items-center mb-2">
            <div class="flex align-items-center">
              <img src={reddot} alt=""/>
              <p class="font-normal text-sm pl-1">{t('SchemeNotAvailed')}</p>
            </div>
          </div>
          <DataTable
            value={inactiveSchemes}
            scrollable
            scrollHeight="18rem"
            filters={filters}
            filterDisplay="row"
          >
            <Column
              field="activityname"
              header={t('SchemeName')}
              headerStyle={{ color: "#333333", fontSize: "12px", fontWeight: 600 }}
              body={(rowData) => (
                renderSchema(rowData)
              )}
              filter
              filterPlaceholder={t('Search')}
              showFilterMenu={false}
              filterElement={nonAvailedSchemesFilterTemplate}
            ></Column>
          </DataTable>
          <p data-testid="non-availed-schemes-total"
            class="font-medium text-sm">{inactiveSchemes.length} {t('TotalRecords')}</p>
        </div>
      </div>
    </div>
  );
};

export default AshaSchemeView;
